import {Component, HostListener, Injector, OnInit} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {BaseComponents} from '../../shared/base-components';
import {TYPE_META} from '../../core/constants/meta_title.constant';

@Component({
    selector: 'app-a-montreal',
    templateUrl: './politica-privacidade.component.html',
    styleUrls: ['./politica-privacidade.component.sass']
})
export class PoliticaPrivacidadeComponent extends BaseComponents implements OnInit {

    @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
        this.handleMobile();
    }

    constructor(protected injector: Injector,
                protected titleService: Title,
                protected meta: Meta) {
        super(injector);
    }


    ngOnInit(): void {
        super.ngOnInit();
        this.setMetaTitle(TYPE_META.POLITICA_PRIVACIDADE);
    }
}
